import { useState } from "react";
//primereact
import { Skeleton } from "primereact/skeleton";
import { Accordion, AccordionTab } from "primereact/accordion";
//pages
import Tax from "./Tax";
import Corrections from "./Corrections";

export default function Financing({ loading }) {
  const [activeIndexAccordion, setActiveIndexAccordion] = useState(0);
  return (
    <>
      {loading ? (
        <>
          <div className="d-flex">
            <Skeleton width="100%" height="300px" />
          </div>
          <div className="row mt-4">
            <div className="col-md-6 d-flex justify-content-start">
              <Skeleton width="20%" height="50px" />
            </div>
            <div className="col-md-6 d-flex justify-content-end">
              <Skeleton width="20%" height="50px" />
            </div>
          </div>
        </>
      ) : (
        <>
          <Accordion
            activeIndex={activeIndexAccordion}
            onTabChange={(e) => setActiveIndexAccordion(e.index)}
          >
            <AccordionTab
              header={
                <div className="flex align-items-center">
                  <i className="fa-solid fa-wrench"></i>
                  <span className="mx-2 vertical-align-middle">
                    Correções Financiamento *
                  </span>
                </div>
              }
            >
              <Corrections setActiveIndex={setActiveIndexAccordion}/>
            </AccordionTab>
            <AccordionTab
              header={
                <div className="flex align-items-center">
                  <i className="fa-solid fa-gear"></i>
                  <span className="mx-2 vertical-align-middle">
                    Configurações de Taxas do Financiamento *
                  </span>
                </div>
              }
            >
              <Tax setActiveIndex={setActiveIndexAccordion}/>
            </AccordionTab>
          </Accordion>
        </>
      )}
    </>
  );
}
